import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { apiFetch } from '../utils/api';
import PageHeader, { btnPrimary, cardClass, btnSecondary } from '../components/PageHeader';

const PendingRegistrations = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    apiFetch('/admin/registrations/pending')
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const approve = async (id) => {
    try {
      await apiFetch(`/admin/registrations/${id}/approve`, { method: 'POST' });
      toast.success('Approved — customer can log in');
      load();
    } catch (err) {
      toast.error(err.message || 'Approve failed');
    }
  };

  const reject = async (id) => {
    const note = window.prompt('Optional reason for rejection:');
    if (note === null) return;
    try {
      await apiFetch(`/admin/registrations/${id}/reject`, {
        method: 'POST',
        body: JSON.stringify({ note }),
      });
      toast.success('Registration rejected');
      load();
    } catch (err) {
      toast.error(err.message || 'Reject failed');
    }
  };

  return (
    <div>
      <PageHeader
        title="Pending registrations"
        subtitle="Commercial signups waiting for admin follow-up"
      />

      <div className={cardClass}>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-left">
            <tr>
              <th className="px-5 py-3">Company</th>
              <th className="px-5 py-3">Contact</th>
              <th className="px-5 py-3">Email</th>
              <th className="px-5 py-3">Phone</th>
              <th className="px-5 py-3">Notes</th>
              <th className="px-5 py-3">Submitted</th>
              <th className="px-5 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="px-5 py-8 text-center text-slate-500">
                  Loading…
                </td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-5 py-8 text-center text-slate-500">
                  No pending commercial registrations
                </td>
              </tr>
            ) : (
              items.map((row) => (
                <tr key={row.id} className="border-t border-slate-100">
                  <td className="px-5 py-3 font-medium">{row.name}</td>
                  <td className="px-5 py-3">{row.customer_name}</td>
                  <td className="px-5 py-3">{row.customer_email}</td>
                  <td className="px-5 py-3">{row.customer_phone || '—'}</td>
                  <td className="px-5 py-3 max-w-xs truncate">{row.registration_notes || '—'}</td>
                  <td className="px-5 py-3">
                    {new Date(row.registered_at).toLocaleString()}
                  </td>
                  <td className="px-5 py-3 text-right space-x-2">
                    <button type="button" onClick={() => approve(row.id)} className={btnPrimary}>
                      Approve
                    </button>
                    <button type="button" onClick={() => reject(row.id)} className={btnSecondary}>
                      Reject
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingRegistrations;
